import React from 'react';
import './Pending.css';

const Evaluation = ({ day }) => {
  return (
   
    <div className="pending-empty">
        <p>No pending Evaluation found</p>
      </div>
  );
};

export default Evaluation;